// Synthetic placeholder emails are created server-side for phone-only customers
// (so the users.email unique index doesn't collide). They look like
// `phone+abc123@no-email.deluxlimo`. They must never be shown to a customer
// or used as the recipient for emails / PDFs / referral links.

export function isPlaceholderEmail(email) {
  if (!email) return true;
  if (email.endsWith("@no-email.deluxlimo")) return true;
  if (/^phone\+[a-z0-9]+@no-email\./i.test(email)) return true;
  return false;
}

// Returns the email when it's real, otherwise an empty string.
export function realEmail(email) {
  return isPlaceholderEmail(email) ? "" : email;
}
